import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { AbstractConstructor, Constructor } from './constructor';

export interface CanDisable {
  /** Whether the component is disabled. */
  disabled: boolean;
}

type CanDisableCtor = Constructor<CanDisable> & AbstractConstructor<CanDisable>;

/**
 * Mixin to augment a directive with a `disabled` property.
 */
export function mixinDisabled<T extends AbstractConstructor<NonNullable<unknown>>>(base: T): CanDisableCtor & T;
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function mixinDisabled<T extends Constructor<NonNullable<unknown>>>(base: T): CanDisableCtor & T {
  return class extends base {
    private _disabled: boolean = false;

    get disabled(): boolean {
      return this._disabled;
    }

    set disabled(value: any) {
      this._disabled = coerceBooleanProperty(value);
    }

    constructor(...args: any[]) {
      super(...args);
    }
  };
}
